var Dispatcher = require('flux').Dispatcher;

/** Creates a singlar instance of Facebook's Dispatcher */
var AppDispatcher = new Dispatcher();

module.exports = AppDispatcher;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mcfly/lib/Dispatcher.js
 ** module id = 3
 ** module chunks = 0
 **/